export { default } from './ListOfCities';
